import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { onKeyActivate } from "@/utils/index";

/**
 * 语言切换
 * @param locale 语言
 * @param isDefault 是否默认语言
 */
const LanguageSwitchLink = ({ locale, isDefault }: { locale: string; isDefault: Boolean }) => {
  const { t } = useTranslation();

  const router = useRouter();
  const { pathname, asPath, query } = router;

  if (isDefault) {
    return (
      <div className="flex h-10 min-w-108px cursor-default items-center px-6 font-semibold text-primary">
        {t(`menu.${locale}`)}
      </div>
    );
  } else {
    return (
      <div
        className="flex h-10 min-w-108px cursor-pointer items-center px-6 font-semibold text-stone-100 hover:text-primary transition-colors duration-200"
        onClick={() => {
          document.cookie = `NEXT_LOCALE=${locale}; max-age=31536000; path=/`;
          router.push({ pathname, query }, asPath, { locale: locale });
        }}
        role="button"
        tabIndex={0}
        onKeyDown={onKeyActivate(() => {
          document.cookie = `NEXT_LOCALE=${locale}; max-age=31536000; path=/`;
          router.push({ pathname, query }, asPath, { locale: locale });
        })}
        data-qt="locale_switch_click"
        data-qt-locale={locale}
      >
        {t(`menu.${locale}`)}
      </div>
    );
  }
};

export default LanguageSwitchLink;
